import ComponentProperty from "../../components/ComponentProperty";
import RangedTextStyle from "../../textStyles/RangedTextStyle";

import { VariableReference } from "../../variables/Variables";

import Blur from "./Blur";
import Border from "./Border";
import Constraints from "./Constraints";
import CornerRadius from "./CornerRadius";
import Fill from "./Fill";
import LayerEffectStyle from "./LayerEffectStyle";
import LayerHash from "./LayerHash";
import Layout, { LayoutAlignment } from "./Layout";
import Rect from "./Rect";
import Shadow from "./Shadow";
import ZeplinBlendMode from "./ZeplinBlendMode";

export const LAYER_TYPES = ["text", "shape", "group"] as const;

export enum GridChildAlignment {
    Center = "center",
    Max = "max",
    Min = "min",
    Auto = "auto"
}

export type LayerType = typeof LAYER_TYPES[number];

// When new fields added to the layer model, check if you need to put same field
// to the screen version diff logic.
export default interface Layer {
    _id: string;
    sourceId?: string;
    type: LayerType;
    name: string;
    rect: Rect;
    minWidth?: number;
    maxWidth?: number;
    minHeight?: number;
    maxHeight?: number;
    renderRect?: Rect;
    fills: Fill[];
    borders: Border[];
    shadows: Shadow[];
    blur?: Blur;
    layout?: Layout;
    rotation?: number;
    borderRadius: number;
    cornerRadius?: CornerRadius;
    textStyles?: RangedTextStyle[];
    content?: string;
    opacity: number;
    blendMode?: ZeplinBlendMode;
    exportable?: boolean;
    componentName?: string;
    componentId?: string;
    componentProperties?: ComponentProperty[];
    interactionLevel?: string;
    layers?: Layer[];
    constraints?: Constraints;
    styleName?: string;
    textStyleName?: string;
    layoutGrow?: number;
    layoutAlignment?: LayoutAlignment;
    textStyleSourceId?: string;
    parent?: Layer | null;
    fromLibrary?: boolean;
    libraryName?: string;
    bitmapImageHash?: string;
    layerHashes?: LayerHash[];
    variableReferences?: VariableReference[];
    fillStyle?: LayerEffectStyle;
    borderStyle?: LayerEffectStyle;
    effectStyle?: LayerEffectStyle;

    // Figma grid
    gridChildHorizontalAlignment?: GridChildAlignment;
    gridChildVerticalAlignment?: GridChildAlignment;
    gridColumnIndex?: number;
    gridColumnSpan?: number;
    gridRowIndex?: number;
    gridRowSpan?: number;
}
